import { useDashboard } from "@platform/features/dashboard/DashboardContext";
import { useChat } from "../../ChatContext";
import { useChatActions } from "../../hooks/useChat";
import { useTalkJSData } from "../../hooks/useChat";
import { useChatVisibility } from "../../hooks/useChatVisibility";
import { ChatSheet } from "./ChatSheet";

export function ChatSheetContainer() {
  const { isOpen } = useChat();

  const { closeChat } = useChatActions();

  const talkjsData = useTalkJSData();

  const { user } = useDashboard();

  const { shouldShowChat, isLoading: isChatStatusLoading } =
    useChatVisibility();

  // Don't render chat sheet if chat is disabled
  if (!isChatStatusLoading && !shouldShowChat) {
    return null;
  }

  return (
    <ChatSheet
      isLoading={!talkjsData || !user || isChatStatusLoading}
      isOpen={isOpen}
      onClose={closeChat}
      talkjsData={talkjsData}
      user={user}
    />
  );
}

export default ChatSheetContainer;
